import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { LoadGeneralService } from '../../services/load-general.service';

@Component({
  selector: 'app-load-general',
  standalone: true,
  imports: [CommonModule, MatProgressBarModule, LottieComponent],
  templateUrl: './load-general.component.html',
  styleUrl: './load-general.component.scss',
})
export class LoadGeneralComponent {
  public readonly inputLoad = input<boolean | undefined>(undefined, {
    alias: 'load',
  });
  public readonly inputUseLottie = input<boolean | undefined>(undefined, {
    alias: 'lottie',
  });

  public readonly load = computed(() => this.inputLoad() ?? this.loadGeneralService.load());
  public readonly useLottie = computed(
    () => this.inputUseLottie() ?? this.loadGeneralService.useLottie(),
  );
  public readonly showProgress = computed(() => this.loadGeneralService.showProgress());
  public readonly progress = computed(() => this.loadGeneralService.progress());

  public readonly lottieOptions: AnimationOptions = {
    path: '/assets/animations/loading2.json',
  };

  constructor(private loadGeneralService: LoadGeneralService) {}
}
